// Stripe product & price IDs
//
// AutoPitch is positioned as an outcome-based AI SDR.
// Pricing: First qualified meeting is free → $49/mo Starter after.
// Growth Packs are PERFORMANCE-GATED add-ons on top of Starter — they unlock
// eligibility ceilings; actual DFY inboxes are only provisioned as the
// tenant's campaigns earn each Growth Mode stage (Explore → Validate → Exploit).

export const STRIPE_PLANS = {
  starter: {
    product_id: "prod_UNE8kPHMdrxBtD",
    price_id: "price_1TOTgHL9axXtg9jS0ufdrlOj",
    name: "Starter",
    price: 49,
  },
} as const;

// Growth Mode add-ons. Buying these does NOT instantly grant inbox volume.
// It grants the *ceiling* the growth-allocator can scale a campaign up to
// once it clears the configured KPI thresholds.
export const GROWTH_PACKS = {
  pack1: {
    key: "pack1",
    product_id: "prod_USmUOppKBE4RUi",
    price_id: "price_1TTqvlL9axXtg9jSGPC14BGU",
    name: "Growth Pack 1",
    price: 199,
    inbox_ceiling: 20,
    domain_ceiling: 4,
    tagline: "Validate what works",
    description: "Up to 20 DFY inboxes across 4 burner domains (5 inboxes per domain), unlocked as your campaigns prove out.",
  },
  pack2: {
    key: "pack2",
    product_id: "prod_USmUqVmFNAqTSY",
    price_id: "price_1TTqvmL9axXtg9jSojWrQmfj",
    name: "Growth Pack 2",
    price: 449,
    inbox_ceiling: 50,
    domain_ceiling: 10,
    tagline: "Scale the winners",
    description: "Up to 50 DFY inboxes across 10 burner domains (5 inboxes per domain) for campaigns hitting validate-stage KPIs.",
  },
  pack3: {
    key: "pack3",
    product_id: "prod_USmUHHZavA6bKs",
    price_id: "price_1TTqvnL9axXtg9jSA1Ofxy3M",
    name: "Growth Pack 3",
    price: 899,
    inbox_ceiling: 100,
    domain_ceiling: 20,
    tagline: "Exploit at full volume",
    description: "Up to 100 DFY inboxes across 20 burner domains (5 inboxes per domain) for proven exploit-stage campaigns.",
  },
} as const;

export type GrowthPackKey = keyof typeof GROWTH_PACKS;

// Reverse lookup: product_id → plan/pack
export function getPlanByProductId(productId: string) {
  return Object.values(STRIPE_PLANS).find((p) => p.product_id === productId) ?? null;
}

export function getGrowthPackByProductId(productId: string) {
  return Object.values(GROWTH_PACKS).find((p) => p.product_id === productId) ?? null;
}

export function getGrowthPackByPriceId(priceId: string) {
  return Object.values(GROWTH_PACKS).find((p) => p.price_id === priceId) ?? null;
}

// Product ID → DB tier mapping (Starter only — Growth Packs do NOT change tier)
export const PRODUCT_TIER_MAP: Record<string, string> = {
  [STRIPE_PLANS.starter.product_id]: "starter",
};
